__turbopack_context__.v({
  "Address": "XeGj7a_Address",
  "ArrowIcon": "XeGj7a_ArrowIcon",
  "Button": "XeGj7a_Button",
  "IconWrapper": "XeGj7a_IconWrapper",
  "Item": "XeGj7a_Item",
  "Item--Active": "XeGj7a_Item--Active",
  "List": "XeGj7a_List",
  "Name": "XeGj7a_Name",
  "NoResults": "XeGj7a_NoResults",
  "Root": "XeGj7a_Root",
  "Root--ConnectionsPage": "XeGj7a_Root--ConnectionsPage",
  "SkeletonAddress": "XeGj7a_SkeletonAddress",
  "SkeletonIcon": "XeGj7a_SkeletonIcon",
  "SkeletonItem": "XeGj7a_SkeletonItem",
  "SkeletonName": "XeGj7a_SkeletonName",
  "SkeletonStatus": "XeGj7a_SkeletonStatus",
  "SkeletonText": "XeGj7a_SkeletonText",
  "TextWrapper": "XeGj7a_TextWrapper",
  "holdings-skeleton-fade": "XeGj7a_holdings-skeleton-fade",
  "skeleton-loading": "XeGj7a_skeleton-loading",
});
